module.exports = __webpack_public_path__ + "img/team5.adb4210.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/team/team5.jpg
// module id = ./static/images/team/team5.jpg
// module chunks = 3